const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/task-assignment/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { taskAssignmentSearchSchema } from '@/features/task-assignment/types/taskAssignment';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/supervisor/task-assignment/new')({
  beforeLoad: requireCapabilities(has => has('manual-task.requests.update')),
  validateSearch: taskAssignmentSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});